<div class="sidebar-title-container">
  <ion-label class="sidebar-title">Visitor services</ion-label>
</div>
<div class="no-color-container">
  <div class="text-container" *ngIf="!generalView">
    <ion-item button [routerLink]="['/documents']" [routerDirection]="'forward'">
      <ion-text color="text">
        <p class="link-anchor">Housing Information</p>
      </ion-text>
    </ion-item>
    <ion-item button [routerLink]="['/documents']" [routerDirection]="'forward'">
      <ion-text color="text">
        <p class="link-anchor">Insurance Needs</p>
      </ion-text>
    </ion-item>
    <ion-item button [routerLink]="['/documents']" [routerDirection]="'forward'">
      <ion-text color="text">
        <p class="link-anchor">Resource Library</p>
      </ion-text>
    </ion-item>
    <div class="text-container" *ngIf="generalView">
      <ion-text color="text">
        <p>{{textcontent?.shared?.generalSidebar?.visitors?.componentContent}}</p>
      </ion-text>
      <ion-item button (click)="openServices()">
        <p class="link-anchor">{{textcontent?.shared?.generalSidebar?.visitors?.componentLink}}</p>
      </ion-item>
    </div>
  </div>